// src/components/ui/PublicFooter.js
import React from 'react';

const PublicFooter = () => {
    return (
        <footer className="bg-gray-800 pt-16 pb-12"> {/* Changed class to className */}
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8"> {/* Changed class to className */}
                {/* Footer Main Content */} {/* Changed HTML comment to JSX comment */}
                <div className="grid md:grid-cols-4 gap-8 mb-12"> {/* Changed class to className */}
                    {/* Column 1: Logo and Info */} {/* Changed HTML comment to JSX comment */}
                    <div className="col-span-1"> {/* Changed class to className */}
                        <div className="flex items-center mb-4"> {/* Changed class to className */}
                            <div className="h-10 w-10 mr-2 bg-gradient-to-br from-primary-600 to-primary-800 rounded-lg flex items-center justify-center shadow-sm"> {/* Changed class to className */}
                                {/* Modified to use Tomorrow font with 600 weight explicitly */} {/* Changed HTML comment to JSX comment */}
                                {/* Changed class to className and converted inline style string to object */}
                                <span className="font-tomorrow font-semibold text-xl text-white" style={{ fontFamily: "'Tomorrow', sans-serif", fontWeight: 600 }}>N²</span>
                            </div>
                            <span className="font-tomorrow font-bold text-xl text-white">Dual N-Back</span> {/* Changed class to className */}
                        </div>
                        <p className="text-gray-400 text-sm mb-4"> {/* Changed class to className */}
                            Advanced brain training with adaptive difficulty, analytics, and social features.
                        </p>
                    </div>

                    {/* Column 2: Features */} {/* Changed HTML comment to JSX comment */}
                    <div className="col-span-1"> {/* Changed class to className */}
                        <h3 className="font-semibold text-white mb-4">Features</h3> {/* Changed class to className */}
                        <ul className="space-y-2"> {/* Changed class to className */}
                            <li>
                                <a href="/#progression" className="text-gray-400 hover:text-white transition-colors">Micro-Level Progression</a> {/* Changed class to className */}
                            </li>
                            <li>
                                <a href="/#analytics" className="text-gray-400 hover:text-white transition-colors">Advanced Analytics</a> {/* Changed class to className */}
                            </li>
                            <li>
                                <a href="/#journal" className="text-gray-400 hover:text-white transition-colors">Training Journal</a> {/* Changed class to className */}
                            </li>
                            <li>
                                <a href="/#social" className="text-gray-400 hover:text-white transition-colors">Social Features</a> {/* Changed class to className */}
                            </li>
                            <li>
                                <a href="/#tools" className="text-gray-400 hover:text-white transition-colors">Practical Tools</a> {/* Changed class to className */}
                            </li>
                        </ul>
                    </div>

                    {/* Column 3: Resources */} {/* Changed HTML comment to JSX comment */}
                    {/* The original HTML had this commented out, so we keep it commented out with JSX syntax */}
                    {/*
                    <div className="col-span-1">
                        <h3 className="font-semibold text-white mb-4">Resources</h3>
                        <ul className="space-y-2">
                            <li>
                                <a href="#" className="text-gray-400 hover:text-white transition-colors">FAQ</a>
                            </li>
                            <li>
                                <a href="/contact.html" className="text-gray-400 hover:text-white transition-colors">Contact Support</a>
                            </li>
                        </ul>
                    </div>
                    */}

                    {/* Column 4: Legal */} {/* Changed HTML comment to JSX comment */}
                    <div className="col-span-1"> {/* Changed class to className */}
                        <h3 className="font-semibold text-white mb-4">Legal</h3> {/* Changed class to className */}
                        <ul className="space-y-2"> {/* Changed class to className */}
                            <li>
                                {/* Consider using <Link> from react-router-dom if these are internal app routes */}
                                <a href="/terms" className="text-gray-400 hover:text-white transition-colors">Terms of Service</a> {/* Changed class to className */}
                            </li>
                            <li>
                                <a href="/privacy" className="text-gray-400 hover:text-white transition-colors">Privacy Policy</a> {/* Changed class to className */}
                            </li>
                        </ul>
                    </div>
                </div>

                {/* Footer Bottom with Copyright */} {/* Changed HTML comment to JSX comment */}
                <div className="pt-8 border-t border-gray-700 flex flex-col md:flex-row justify-between items-center"> {/* Changed class to className */}
                    <p className="text-gray-400 text-sm">© 2025 Dual N-Back, LLC. All rights reserved.</p> {/* Changed class to className */}
                    <div className="mt-4 md:mt-0 flex space-x-6"> {/* Changed class to className */}
                        {/* Consider using <Link> for internal routes */}
                        <a href="/index" className="text-gray-400 hover:text-gray-300 text-sm">Home</a> {/* Changed class to className */}
                        <a href="/plans" className="text-gray-400 hover:text-gray-300 text-sm">Sign Up</a> {/* Changed class to className */}
                        <a href="https://app.dualnback.com/login" className="text-gray-400 hover:text-gray-300 text-sm">Login</a> {/* Changed class to className */}
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default PublicFooter;